<template>
    <!-- segmented control: the selected option on the teal-to-blue gradient -->
    <div class="cl-segment" :class="{ 'cl-segment--light': light }" role="tablist">
        <button
            v-for="(item, index) in options"
            :key="index"
            type="button"
            role="tab"
            class="cl-segment__option"
            :class="{ 'cl-segment__option--active': option === index, 'cl-segment__option--empty': counts && counts[index] === 0 }"
            :aria-selected="option === index"
            @click="option = index"
        >
            {{ item }}
            <!-- how many matches the option holds: a hint before the click; an option without any is dimmed -->
            <span v-if="counts && counts[index] !== null && counts[index] !== undefined" class="cl-segment__count">{{ counts[index] }}</span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                default: () => ['Regular Season', 'Play Offs', 'Cup']
            },
            // on a light background
            light: {
                type: Boolean,
                default: false
            },
            // optional: the number of matches of every option (null while unknown)
            counts: {
                type: Array,
                default: null
            }
        },
        data() {
            return {
                option: 0
            }
        },
        watch: {
            option: {
                handler() {
                    this.$emit('setType', this.option)
                }
            }
        }
    }
</script>

<style scoped>
.cl-segment {
    display: inline-flex;
    flex-wrap: nowrap;
    gap: 4px;
    padding: 4px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
}

.cl-segment__option {
    padding: 7px 18px;
    white-space: nowrap;
    border-radius: 999px;
    color: rgba(255, 255, 255, 0.75);
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    transition: background 0.15s, color 0.15s;
}

.cl-segment__option--empty:not(.cl-segment__option--active) {
    opacity: 0.45;
}

.cl-segment__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 18px;
    margin-left: 6px;
    padding: 0 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    font-size: 0.7rem;
    font-weight: 800;
    line-height: 1;
}

.cl-segment__option--active .cl-segment__count {
    background: rgba(255, 255, 255, 0.28);
}

.cl-segment__option:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
}

.cl-segment--light {
    background: #232323;
    border-color: #232323;
}

.cl-segment__option--active,
.cl-segment__option--active:hover {
    color: #fff;
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    box-shadow: 0 2px 10px rgba(3, 122, 222, 0.35);
}
</style>
